import React from 'react';
import DOMPurify from 'dompurify';

/**
 * @description Sanitizes a potentially unsafe HTML string and renders it in a div
 * @param {string} HTMLContent Potentially unsafe HTML string
 * @param {object} options dompurify sanitization options (https://www.npmjs.com/package/dompurify)
 * @param {string} className CSS class(es) to apply to the div
 */
const RawHTML = ({ HTMLContent = '', options = {}, className = '' }) => (
    <div 
        className={className}
        dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(HTMLContent, options),
        }}
    />
);

export default RawHTML;
